import React, { useState, useRef, useCallback, useMemo } from 'react';
import debounce from 'lodash/debounce';
import classnames from 'classnames/bind';
import { apiHolder, reDefinedColorList, apis, } from 'api';
import lodashGet from 'lodash/get';
import { Dropdown, Modal, Tooltip, Collapse } from 'antd';
import { ReactComponent as CaretRightOutlined } from '@/images/icons/arrow_expand_gray.svg';
import { ReactComponent as CaretDownOutlined } from '@/images/icons/arrow-down.svg';
import globalMessage from '@web-common/components/UI/Message/SiriusMessage';
import { MailTagIcon, AddTagIcon, TagCheckedIcon } from './Icon';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import style from './MailTag.module.scss';
import { useActions, useAppSelector, MailClassifyActions, useAppDispatch } from '@web-common/state/createStore';
import { getTreeStatesByAccount, isMainAccount, mailConfigStateIsMerge, transTag2Name, isLockTag } from '../../util';
import InputContextMenu from '@web-common/components/UI/InputContextMenu/InputContextMenu';
import LxInput from '@lingxi-common-component/sirius-ui/Input';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import { getIn18Text } from 'api';
import MailTagHotKeyInput from './MailTagHotKeyInput';
import Badge from '@web-common/components/UI/SiriusBadge';
import TagGuide from './TagGuide';
import { actions as hkActions } from '@web-common/state/reducer/hotkeysReducer';
const { Panel } = Collapse;
const mailManagerApi = apiHolder.api.requireLogicalApi('mailConfApiImpl');
const systemApi = apiHolder.api.getSystemApi();
const storeApi = apiHolder.api.getDataStoreApi();
const eventApi = apiHolder.api.getEventApi();
const upgradeAppApi = apiHolder.api.requireLogicalApi(apis.upgradeAppApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const realStyle = classnames.bind(style);
export { MailTagIcon, AddTagIcon, TagCheckedIcon } from './Icon';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const __globalTagColor = {
    count: -1,
};
const GLOBAL_TAG_COLOR = new Proxy(__globalTagColor, {
    get(target, prop) {
        switch (prop) {
            case 'count':
                return Reflect.get(target, prop) >= 0 ? Reflect.get(target, prop) : [...reDefinedColorList[0].nums].pop();
            case 'setNext':
                return (count) => {
                    var _a;
                    let $index = reDefinedColorList.map(item => item.nums).findIndex(item => item.includes(count));
                    $index = $index === -1 || $index >= reDefinedColorList.length - 1 ? 0 : $index + 1;
                    const colors = (_a = reDefinedColorList[$index]) === null || _a === void 0 ? void 0 : _a.nums;
                    Reflect.set(target, 'count', [...colors].pop());
                };
            case 'setPrev':
                return (count) => {
                    var _a;
                    let $index = reDefinedColorList.map(item => item.nums).findIndex(item => item.includes(count));
                    $index = $index <= 0 ? 0 : $index - 1;
                    const colors = (_a = reDefinedColorList[$index]) === null || _a === void 0 ? void 0 : _a.nums;
                    Reflect.set(target, 'count', [...colors].pop());
                };
            default:
                return new Error('undefined property');
        }
    },
});
export const TagModal = React.forwardRef((props, _) => {
    const { data, type = 'replace', afterClose, markWhenAdd, activeIds, container, onTagAdded = () => { }, mask = true, maskClosable = true, tagList, account } = props;
    const [errorMsg, setErrorMsg] = useState('');
    const [visible, setVisible] = useState(true);
    const [tagName, setTagName] = useState(data[0] || '');
    const mailTagHkInput = useRef(null);
    const [tagColor, setTagColor] = useState(() => {
        var _a;
        if (type === 'replace' || type === 'update') {
            return (_a = data[1]) === null || _a === void 0 ? void 0 : _a.color;
        }
        return GLOBAL_TAG_COLOR.count;
    });
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const editTag = async () => {
        var _a;
        let _errorMsg = '';
        if (tagList && tagList.length && data) {
            let sum = 0;
            tagList.forEach(i => {
                var _a, _b;
                if (i[0] && ((_a = i[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == ((_b = data[0]) === null || _b === void 0 ? void 0 : _b.toLowerCase())) {
                    sum++;
                }
            });
            const isRepeat = sum > 1;
            if (isRepeat) {
                _errorMsg = getIn18Text('YICUNZAITONGMING11');
                setErrorMsg(_errorMsg);
                return Promise.reject(new Error(_errorMsg));
            }
        }
        try {
            const requestParam = isCorpMail
                ?
                    [[(_a = data[1]) === null || _a === void 0 ? void 0 : _a.tagId, { color: tagColor, name: tagName }]]
                : [[data[0], { color: tagColor, alias: tagName, isShow: 1 }]];
            const res = await mailManagerApi.manageTag(type, requestParam, tagName, account);
            mailTagHkInput.current &&
                mailTagHkInput.current.updateHk2Local({
                    oldName: data[0],
                    name: tagName,
                });
            eventApi.sendSysEvent({
                eventName: 'mailTagChanged',
                eventData: {
                    oldTag: data[0],
                    updateTag: tagName,
                    _account: account,
                },
                eventStrData: 'updateTag',
                _account: account,
            });
            globalMessage.success({ content: getIn18Text('XIUGAIBIAOQIANCHENG'), duration: 1 });
            return res;
        }
        catch (ex) {
            _errorMsg = lodashGet(ex, 'message', getIn18Text('XIUGAIBIAOQIANSHI'));
            setErrorMsg(_errorMsg);
            return Promise.reject(new Error(_errorMsg));
        }
    };
    const addTag = async (noSuccessTip = false) => {
        try {
            const res = await mailManagerApi.manageTag('add', [[tagName, { color: tagColor }]], tagName, account);
            onTagAdded(tagName, tagColor);
            if (!noSuccessTip) {
                globalMessage.success({ content: getIn18Text('XINJIANBIAOQIANCHENG'), duration: 1 });
            }
            return res;
        }
        catch (ex) {
            setErrorMsg(lodashGet(ex, 'message', getIn18Text('XINJIANBIAOQIANSHI')));
            return Promise.reject(ex);
        }
    };
    const markTag = () => {
        globalMessage.loading({ content: getIn18Text('BIAOJIZHONG'), duration: 35, key: tagName });
        eventApi.sendSysEvent({
            eventName: 'mailTagChanged',
            eventData: {
                tagNames: [tagName],
                mailList: activeIds,
                tagIds: [undefined],
                isNewTag: true,
            },
            eventStrData: 'tag',
            _account: account,
        });
    };
    const addTagAndMark = async () => {
        await addTag(true);
        markTag();
    };
    const submit = () => {
        if (type === 'replace' || type === 'update') {
            return editTag();
        }
        if (type === 'add') {
            mailTagHkInput.current && mailTagHkInput.current.saveHk2Local(tagName);
            if (!markWhenAdd) {
                return addTag();
            }
            return addTagAndMark();
        }
        return Promise.resolve();
    };
    const inputRef = useRef(null);
    return (React.createElement(SiriusModal, { title: type === 'replace' || type === 'update' ? getIn18Text('XIUGAIBIAOQIAN') : getIn18Text('XINJIANBIAOQIAN'), visible: visible, okText: getIn18Text('QUEDING'), cancelText: getIn18Text('QUXIAO'), width: 440, maskClosable: maskClosable, mask: mask, getContainer: () => container || document.getElementById('mailboxModule') || document.body, onOk: async () => {
            try {
                const res = mailTagHkInput.current && mailTagHkInput.current.valid(tagName);
                let staticRes = res;
                if (res === null || res === void 0 ? void 0 : res.then) {
                    try {
                        await res;
                        staticRes = true;
                    }
                    catch (e) {
                        staticRes = false;
                    }
                }
                if (staticRes) {
                    await submit();
                    if (type === 'add') {
                        GLOBAL_TAG_COLOR.setNext(tagColor);
                    }
                    setVisible(false);
                }
            }
            catch (e) {
                console.error('[error] mail tag model error', e);
            }
        }, onCancel: () => {
            setVisible(false);
        }, afterClose: () => {
            afterClose(false);
        }, okButtonProps: {
            'data-test-id': 'mailtag-submit-button',
            disabled: tagName.trim().length === 0 || tagColor === -1,
            'data-test-id': 'mail-submit-button',
        }, className: style.tagModalWrap, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }) },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: realStyle('subTitle') }, "\u6807\u7B7E\u540D\u79F0"),
            React.createElement(InputContextMenu, { inputOutRef: inputRef, changeVal: setTagName },
                React.createElement(LxInput, { autoFocus: type !== 'replace' && type !== 'update', ref: inputRef, type: "text", value: tagName, maxLength: 20, "data-test-id": "mail-tag-name-input", style: { marginTop: 8 }, "data-test-id": "mailtag-tag-name-input", onChange: e => {
                        let val = e.target.value;
                        let remainLength = 20;
                        let actualLength = 0;
                        while (remainLength >= 0 && val.length) {
                            const unitChart = val.slice(0, 1);
                            const cnReg = /[\u4e00-\u9fa5]/;
                            const unitLength = cnReg.test(unitChart) ? 2 : 1;
                            val = val.slice(1);
                            if (remainLength - unitLength < 0) {
                                setErrorMsg(getIn18Text('MINGCHENGZUIDUOWEI'));
                                break;
                            }
                            remainLength -= unitLength;
                            actualLength += 1;
                        }
                        setTagName(e.target.value.slice(0, actualLength));
                        setErrorMsg('');
                    }, placeholder: getIn18Text('QINGSHURUBIAOQIAN'), openFix: false })),
            React.createElement("div", { className: realStyle('subTitle'), style: { marginTop: 16 } }, getIn18Text('BIAOQIANKUAIJJ')),
            React.createElement(MailTagHotKeyInput, { tagName: tagName, account: account, style: { marginTop: 8 }, ref: mailTagHkInput }),
            React.createElement("div", { className: realStyle('tagModalBody') },
                errorMsg && React.createElement("p", { className: realStyle('addTagError') }, errorMsg),
                React.createElement("div", { className: realStyle('tagRadioList') },
                    React.createElement("p", { className: realStyle('label') }, getIn18Text('BIAOQIANYANSE')),
                    React.createElement("ul", { className: realStyle('list') }, reDefinedColorList.map(item => (React.createElement("span", { key: item.className, className: realStyle('item'), style: {
                            backgroundColor: item.color,
                        }, "data-test-id": 'mail-tag-color-' + item.color, onClick: () => {
                            const initColor = item.nums[item.nums.length - 1];
                            setTagColor(initColor);
                        } }, item.nums.includes(tagColor) ? React.createElement(TagCheckedIcon, null) : null)))))))));
});
const Item = props => {
    var _a;
    const { data, activeName, disabled = false, tagList, account } = props;
    const dispatch = useAppDispatch();
    const strokeColor = ((_a = reDefinedColorList.find(item => item.nums.includes(data[1].color))) === null || _a === void 0 ? void 0 : _a.color) || '#6BA9FF';
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const deliveryUnread = useAppSelector(state => {
        var _a;
        const _account = isMainAccount(account) ? 'main' : account;
        const map = (_a = state.mailReducer.mailTreeStateMap[_account]) === null || _a === void 0 ? void 0 : _a.wmDeliveryTagUnRead;
        return map || {};
    });
    const isMerge = mailConfigStateIsMerge();
    const { setMailTag, changeShowClassifyModal, setModalAccount, setModalType } = useActions(MailClassifyActions);
    const triggerDeleteTag = async (deleteData) => {
        const tagName = deleteData[0];
        const count = deleteData[2];
        Modal.confirm({
            title: getIn18Text('QUEDINGSHANCHUMA', { tagName: tagName }),
            [`${deleteData[2]}` === '0' ? 'customContent' : 'content']: isMerge
                ? getIn18Text('GAIBIAOQIANJIANGCONG')
                : getIn18Text('GAIBIAOQIANJIANGCONGFYJZSC，DSBHSCYJ', { count: count }),
            okText: getIn18Text('SHANCHU'),
            cancelText: getIn18Text('QUXIAO'),
            async onOk() {
                try {
                    const requestParam = isCorpMail ? [deleteData[1].tagId] : [deleteData[0]];
                    await mailManagerApi.manageTag('delete', requestParam, undefined, account);
                    globalMessage.success({ content: getIn18Text('BIAOQIANSHANCHUCHENG'), duration: 1 });
                    dispatch(hkActions.doUpdateMailTagHotKey({
                        oldName: deleteData[0],
                        name: deleteData[0],
                        hotkey: undefined,
                        account,
                    }));
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {},
                        eventStrData: 'reloadHotKey',
                    });
                    eventApi.sendSysEvent({
                        eventName: 'mailTagChanged',
                        eventData: {
                            tagNames: [deleteData[0]],
                            mailList: [],
                        },
                        eventStrData: 'cleartag',
                        _account: account,
                    });
                }
                catch (ex) {
                    globalMessage.error({ content: getIn18Text('BIAOQIANSHANCHUSHI'), duration: 1 });
                }
            },
            onCancel() {
                return Promise.resolve();
            },
        });
    };
    const setMailTagConfig = (tag) => {
        setMailTag(tag[0]);
        setModalAccount(account);
        setModalType('edit');
        changeShowClassifyModal(true);
        trackApi.track('pcMail_view_mailClassificationNewPage', { type: 'tags' });
    };
    const [editModalVisible, setEditModalVisible] = useState(false);
    const triggerEditTag = () => {
        setTimeout(() => {
            setEditModalVisible(true);
        }, 500);
    };
    const menu = (React.createElement("div", { className: realStyle('tagItemMenu'), onClick: e => {
            e.stopPropagation();
        } },
        React.createElement("div", { onClick: () => {
                !disabled && triggerEditTag();
            }, className: realStyle('menuItem') }, getIn18Text('XIUGAIBIAOQIAN')),
        React.createElement("div", { onClick: () => {
                setMailTagConfig(data);
            }, className: realStyle('menuItem') }, getIn18Text('SHEZHILAIXINFEN')),
        React.createElement("div", { onClick: () => {
                !disabled && triggerDeleteTag(data);
            }, className: realStyle('menuItem') }, getIn18Text('SHANCHUBIAOQIAN')),
        editModalVisible && (React.createElement(TagModal, { data: data, type: isCorpMail ? 'update' : 'replace', tagList: tagList, afterClose: () => {
                setEditModalVisible(false);
            }, account: account }))));
    const chooseMailTag = useCallback(debounce(() => {
        try {
            trackApi.track('pcMail_switch_label_folderList', {
                labelName: data[0],
            });
        }
        catch (err) {
            console.error(err);
        }
        eventApi.sendSysEvent({
            eventName: 'chooseMailTag',
            eventData: data,
            _account: account,
        });
    }, 500, {
        leading: true,
        trailing: true,
    }), [account]);
    const containerRef = useRef(null);
    const [menuVisible, setMenuVisible] = useState(false);
    return (React.createElement("div", { "data-test-id": `mail-tag-${data[0]}`, className: `${realStyle('tagItem')} ${activeName === data[0] ? realStyle('tagItemActive') : ''}`, onClick: () => {
            !disabled && chooseMailTag();
        }, ref: containerRef, onMouseLeave: () => {
            setMenuVisible(false);
        } },
        React.createElement(MailTagIcon, { strokeColor: strokeColor }),
        React.createElement(Dropdown, { getPopupContainer: () => containerRef.current, visible: menuVisible, onVisibleChange: visible => {
                !disabled && setMenuVisible(visible);
            }, overlay: menu, placement: "bottomLeft", trigger: ['contextMenu'], disabled: isLockTag(data[0]) },
            React.createElement("p", { className: realStyle('tagItemName') }, transTag2Name(data[0]))),
        isMerge ? (React.createElement(React.Fragment, null, data[7] > 0 && (React.createElement("span", { className: "u-unread", "data-test-id": "mail-folder-unread" }, data[7])))) : (React.createElement(React.Fragment, null,
            process.env.BUILD_ISEDM && isLockTag(data[0]) && deliveryUnread[data[0]] != 0 ? (React.createElement("span", { className: "u-unread", "data-test-id": "mail-folder-unread" }, deliveryUnread[data[0]])) : (React.createElement(React.Fragment, null)),
            data[5] > 0 && (React.createElement("span", { className: "u-unread", "data-test-id": "mail-folder-unread" }, data[5])))),
        isLockTag(data[0]) ? (React.createElement(React.Fragment, null)) : (React.createElement(Dropdown, { overlay: menu, placement: "bottomLeft", trigger: ['click'] },
            React.createElement("div", { "data-test-id": "mail-tag-more-btn", className: `${realStyle('menuEntry', 'more')}`, onClick: e => {
                    e.stopPropagation();
                } }, "...")))));
};
const presetTags = [getIn18Text('SHENPI'), getIn18Text('GONGZUOHUIBAO'), 'ToMe'];
const TAG_GUIDE = 'tag-guide';
export const MailTag = props => {
    const { activeName, disabled = false, scrollController, account } = props;
    const mailTreeStateMap = useAppSelector(state => state.mailReducer.mailTreeStateMap);
    const tagList = useMemo(() => {
        const folderState = getTreeStatesByAccount(mailTreeStateMap, account || '');
        if (folderState && (folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList)) {
            return folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList;
        }
        return [];
    }, [mailTreeStateMap, account]);
    const [addTagModalVisible, setAddTagModalVisible] = useState(false);
    return (React.createElement("div", { className: realStyle('mailTagWrapper', {
            mailTagDisabled: disabled,
        }) },
        React.createElement(Collapse, { bordered: false, expandIcon: ({ isActive }) => (React.createElement("span", { className: "dark-svg-invert", style: { width: '8px' } }, isActive ? React.createElement(CaretDownOutlined, null) : React.createElement(CaretRightOutlined, null))) },
            React.createElement(Panel, { key: 1, header: React.createElement("div", { className: realStyle('title'), "data-test-id": "mail-tag-panel" },
                    React.createElement("div", { style: {
                            boxSizing: 'border-box',
                            padding: '0px',
                            display: 'flex',
                            alignItems: 'center',
                        }, id: "custom-mail-tag" },
                        React.createElement(MailTagIcon, { strokeColor: '#7d8085' }),
                        React.createElement("span", { style: { marginLeft: '11px' } }, getIn18Text('BIAOQIAN')),
                        React.createElement(TagGuide, null,
                            React.createElement(Badge, { intro: getIn18Text('XINGOGNNENG'), style: { marginLeft: 10 }, onClick: e => e.stopPropagation() }))),
                    React.createElement(Tooltip, { title: getIn18Text('XINJIANBIAOQIAN'), trigger: ['hover'] },
                        React.createElement("span", { "data-test-id": "mail-tag-add-btn", className: realStyle('titleAddBtn'), onClick: e => {
                                e.stopPropagation();
                                !disabled && setAddTagModalVisible(true);
                            } },
                            React.createElement(AddTagIcon, null)))) },
                tagList.map((item, idx) => {
                    return React.createElement(Item, { disabled: disabled, account: account, data: item, key: item[0], activeName: (activeName === null || activeName === void 0 ? void 0 : activeName.key) || '', tagList: tagList });
                }),
                tagList.length === 0 && (React.createElement("div", { className: realStyle('emptyTip') },
                    getIn18Text('WEIYOUJIANDASHANG'),
                    React.createElement("div", { className: realStyle('createEntry'), onClick: () => {
                            !disabled && setAddTagModalVisible(true);
                        } }, getIn18Text('XINJIANBIAOQIAN')))))),
        addTagModalVisible && (React.createElement(TagModal, { account: account, type: "add", data: [], afterClose: () => {
                setAddTagModalVisible(false);
            } }))));
};
